import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getAdminDashboard, getCategoriesList, getProfessionsList } from "../../../services/adminService";
import AdminCategories from "../Categories/AdminCategories";
import AdminProfessions from "../Professions/AdminProfessions";

const AdminDashboard = () => {
  const [dashboardData, setDashboardData] = useState({
    users: 0,
    freelancers: 0,
    businesses: 0,
    service_requests: 0,
  });
  const [categories, setCategories] = useState([]);
  const [professions, setProfessions] = useState([]);
  const [loading, setLoading] = useState(true);

  const navigate = useNavigate();

  useEffect(() => {
    const fetchDashboard = async () => {
      try {
        const [dashboard, categoryData, professionData] = await Promise.all([
          getAdminDashboard(),
          getCategoriesList(),
          getProfessionsList(),
        ]);

        setDashboardData(dashboard);
        setCategories(categoryData);
        setProfessions(professionData);
      } catch (error) {
        console.error("Failed to fetch dashboard:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchDashboard();
  }, []);

  if (loading) return <p>Loading dashboard...</p>;

  return (
    <div className="dashboard-home">
      {/* Dashboard Cards */}
      <div className="dashboard-cards" >
        <div className="dashboard-card" onClick={() => navigate("/admin/users")}>
          <h3>Users</h3>
          <span>{dashboardData.users}</span>
        </div>

        <div className="dashboard-card">
          <h3>Freelancers</h3>
          <span>{dashboardData.freelancers}</span>
        </div>

        <div className="dashboard-card">
          <h3>Businesses</h3>
          <span>{dashboardData.businesses}</span>
        </div>

        <div className="dashboard-card">
          <h3>Service Requests</h3>
          <span>{dashboardData.service_requests}</span>
        </div>
      </div>
    </div>
  );
};

export default AdminDashboard;
